module.exports = __webpack_public_path__ + "static/img/83079B_1_C_20210913_LC.0c3a739.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/83079B_1_C_20210913_LC.png
// module id = JLk6
// module chunks = 0